import React, { useState, useEffect } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import './price4.scss'
import { Helmet } from 'react-helmet';
import PriceInfo from '../../components/PriceInfo/PriceInfo';
import MyButton from '../../components/UI/button/MyButton';
import { useHistory } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
const Price4 = ({ setShowTermBundle, setButtonText, setButtonShow, setPriceBottomShow, setWhiteWrapper, setEventProperties, sessionId, setEventName }) => {
    const history = useHistory();
    useEffect(() => {
        setButtonShow(false);
        if (setWhiteWrapper) {
            setWhiteWrapper(true)
        }
        // setEventName('web_price')
        // setEventProperties({
        //     web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
        //     session_id: sessionId,
        //     user_id: localStorage.getItem('userId')
        // })
        setPriceBottomShow(false);
        // localStorage.setItem("price", 'plus')
        // localStorage.setItem("plan", '4-Week Plan')
        localStorage.setItem("price", 1)
        const setVHVariable = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setVHVariable();
        window.addEventListener('resize', setVHVariable);
        return () => window.removeEventListener('resize', setVHVariable);
    }, []);

    const [activePlan, setActivePlan] = useState(1);
    const [activePrice, setActivePrice] = useState('$29.95');
    const [activeOldPrice, setActiveOldPrice] = useState('$83.00');

    const plans = [
        {
            id: 0,
            name: '2 weeks ',
            price: '$19.95',
            oldPrice: '$42.00',
            priceDay: '$1.42/day',
            sale: '54% OFF',
            features: [
                {
                    text: 'Launch up to 50 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 100 creatives',
                    status: true
                },
                {
                    text: 'Create up to 10 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
        {
            id: 1,
            name: '1 month',
            price: '$29.95',
            oldPrice: '$83.00',
            // activeTrial: 'Most Popular',
            priceDay: '$1.00/day',
            sale: '64% OFF',
            features: [
                {
                    text: 'Launch up to 100 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 250 creatives',
                    status: true
                },
                {
                    text: 'Create up to 20 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
        {
            id: 2,
            name: '2 months',
            price: '$49.95',
            oldPrice: '$167.00',
            priceDay: '$0.86/day',
            sale: '70% OFF',
            features: [
                {
                    text: 'Launch up to 150 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 500 creatives',
                    status: true
                },
                {
                    text: 'Create up to 30 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
    ];

    const handlePlanClick = (planId, planName, planPrice, planOldPrice) => {
        setActivePlan(planId);
        localStorage.setItem("price", planId)
        localStorage.setItem("plan", planName)
        setActivePrice(planPrice)
        setActiveOldPrice(planOldPrice)
    };

    return (
        <div>

            <div className="price4">
                <CustomTitle style={{ marginBottom: "24rem"  }} title="Zeely users see a 164% ad boost in just 2 months" />
                <div>
                {plans.map((plan) => (
                    <div
                        key={plan.id}
                        className={`price-plans__plan ${activePlan === plan.id ? 'price-plans__plan--active' : ''}`}
                        onClick={() => handlePlanClick(plan.id, plan.name, plan.price, plan.oldPrice)}
                    >
                        {plan.activeTrial &&
                            <div className="price-plans__plan-active-trial">{plan.activeTrial}</div>}
                        <div className="price-plans__top price-plans__top--second">

                            <div className="price-plans__top-info">
                                <h2 className="price-plans__plan-title">{plan.name}


                                    

                                </h2>
                                <p className="price-plans__plan-price">
                                {plan.price}
                                <span>{plan.oldPrice}</span>
                            </p>
                                

                            </div>
                   
                            <div className="price-plans__plan-day"><i>{plan.sale}</i> {plan.priceDay}</div>
                        </div>

                    </div>
                ))}
                </div>
               

                <div className="price-info">
                    <div className="price-info-item">
                        <div className="price-info-item__icon">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.6648 9.2897L10.6652 9.32037C10.6659 9.74512 10.4623 10.1546 10.0947 10.4675L10.096 10.4662C9.71317 10.7957 9.1954 11.0107 8.6317 11.0743L8.61847 11.0756V11.8624C8.61847 11.8989 8.5999 11.9339 8.56686 11.9597C8.53381 11.9855 8.48899 12 8.44226 12H7.66445C7.61607 11.9996 7.56984 11.9844 7.53563 11.9577C7.50142 11.9309 7.48196 11.8948 7.48141 11.857V11.0756C7.22429 11.0488 6.97166 11.0002 6.72791 10.9309L6.75309 10.9372C6.389 10.8421 6.04739 10.7009 5.74189 10.5192L5.75042 10.5242C5.65711 10.4715 5.56752 10.4148 5.48205 10.3545L5.48504 10.3565C5.43753 10.3209 5.40425 10.2943 5.3852 10.2765C5.35435 10.2525 5.33614 10.2204 5.33416 10.1864C5.33219 10.1525 5.34659 10.1192 5.37453 10.0931L5.96248 9.49073C5.97811 9.47499 5.9979 9.46208 6.02051 9.45288C6.04312 9.44367 6.068 9.43839 6.09346 9.43739C6.11876 9.43376 6.14528 9.4356 6.16934 9.44271C6.1934 9.44981 6.21452 9.46192 6.23042 9.47773L6.24194 9.48673C6.62772 9.76272 7.09985 9.9543 7.61069 10.0421L7.63031 10.0451C7.75746 10.0678 7.90338 10.0808 8.05314 10.0808L8.07959 10.0811C8.37442 10.0811 8.64748 10.0091 8.87234 9.88644L8.86764 9.88878C8.98105 9.82887 9.07292 9.74726 9.13447 9.65171C9.19602 9.55617 9.22519 9.4499 9.21921 9.34304V9.34438C9.21921 9.2567 9.18721 9.17502 9.13218 9.10601L9.13345 9.10801C9.08144 9.03918 9.01723 8.97644 8.94274 8.92166C8.84356 8.85666 8.73408 8.80112 8.61762 8.75697L8.60823 8.75364C8.45577 8.69274 8.33061 8.64507 8.23276 8.61062C8.13492 8.57617 7.9826 8.52783 7.77581 8.4656C7.62733 8.41804 7.51013 8.38081 7.42423 8.35392C7.33833 8.32703 7.22114 8.28758 7.07266 8.23557C6.92418 8.18356 6.80514 8.13745 6.71554 8.09722C6.62594 8.05699 6.51828 8.00421 6.39255 7.93887C6.28242 7.88342 6.17939 7.81978 6.08493 7.74884C5.99919 7.68106 5.91844 7.61018 5.84216 7.53582L5.83661 7.53048C5.75581 7.45395 5.68877 7.36916 5.63736 7.27845L5.63394 7.27145C5.58439 7.17937 5.54513 7.08412 5.51661 6.98675L5.51362 6.97475C5.48098 6.86298 5.46466 6.74868 5.46498 6.63404V6.61603C5.46498 6.19932 5.67874 5.82127 6.02562 5.5459C6.41227 5.23182 6.91711 5.02314 7.4669 4.94983L7.48226 4.94816V4.14173C7.48226 4.10272 7.50317 4.06738 7.53645 4.04238C7.55289 4.02899 7.57263 4.01834 7.59448 4.01106C7.61633 4.00379 7.63984 4.00004 7.66359 4.00004H8.44311C8.54039 4.00004 8.61932 4.06172 8.61932 4.13772V4.92882C8.85399 4.94816 9.06817 4.9845 9.2734 5.0365L9.25079 5.0315C9.44663 5.07818 9.61132 5.12918 9.76961 5.18852L9.74743 5.18119C9.88737 5.23553 10.0064 5.2912 10.1191 5.35321L10.1105 5.34854C10.2243 5.41122 10.2985 5.45433 10.3332 5.47789C10.3679 5.50145 10.3965 5.52223 10.419 5.54023C10.4497 5.56088 10.4695 5.58965 10.4747 5.62103C10.4799 5.65241 10.4701 5.68419 10.4472 5.71025L9.98593 6.362C9.97441 6.38205 9.95614 6.39927 9.93307 6.41183C9.91 6.4244 9.883 6.43183 9.85495 6.43335C9.82785 6.43775 9.79939 6.43721 9.77261 6.43178C9.74582 6.42634 9.721 6.41616 9.70007 6.40201C9.68869 6.39312 9.66152 6.37534 9.61772 6.34867C9.57392 6.322 9.49968 6.28255 9.395 6.23032C9.29344 6.17945 9.18784 6.13369 9.07884 6.0933L9.06092 6.0873C8.92959 6.04012 8.79307 6.00229 8.65303 5.97429L8.63511 5.97129C8.47606 5.93727 8.31191 5.92 8.147 5.91995C7.83103 5.90864 7.51832 5.97689 7.2557 6.11464L7.26125 6.11197C7.11599 6.18738 7.00789 6.29916 6.9547 6.42893C6.90151 6.5587 6.90639 6.69875 6.96855 6.82606L6.96685 6.82206C7.0061 6.8954 7.06327 6.95741 7.13495 7.00708L7.13581 7.00742C7.2045 7.05776 7.27789 7.1061 7.35469 7.1511L7.36151 7.15477C7.45325 7.20411 7.55863 7.25045 7.66914 7.28912L7.68194 7.29312C7.82473 7.34513 7.93993 7.38535 8.02754 7.4138C8.11515 7.44225 8.24855 7.48314 8.42775 7.53648C8.6297 7.59605 8.78402 7.64294 8.89068 7.67717C8.99735 7.71139 9.14213 7.76351 9.32503 7.83352C9.47909 7.89005 9.62755 7.95546 9.76919 8.02921L9.75681 8.02321C9.88908 8.09655 10.0043 8.1699 10.1139 8.24824L10.1114 8.24624C10.2296 8.32692 10.3303 8.42026 10.4105 8.52461L10.4143 8.52994C10.4851 8.62762 10.5461 8.7413 10.5905 8.86031L10.5944 8.87165C10.6409 8.99333 10.6673 9.13335 10.6673 9.27803V9.29204L10.6648 9.2897Z" fill="black" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00065 13.6C11.0934 13.6 13.6007 11.0928 13.6007 8.00004C13.6007 4.90725 11.0934 2.40004 8.00065 2.40004C4.90786 2.40004 2.40065 4.90725 2.40065 8.00004C2.40065 11.0928 4.90786 13.6 8.00065 13.6ZM8.00065 14.6667C11.6825 14.6667 14.6673 11.6819 14.6673 8.00004C14.6673 4.31814 11.6825 1.33337 8.00065 1.33337C4.31875 1.33337 1.33398 4.31814 1.33398 8.00004C1.33398 11.6819 4.31875 14.6667 8.00065 14.6667Z" fill="black" />
                            </svg>

                        </div>

                        <p>Launch FB & IG campaigns</p>
                    </div>
                    <div className="price-info-item">
                        <div className="price-info-item__icon">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66802 3.19997C3.48981 3.19997 2.53469 4.15509 2.53469 5.3333V9.57103L4.68403 7.55603C5.70151 6.60214 7.29863 6.65008 8.25706 7.66328L9.93836 9.44065L11.1231 8.45321C11.8058 7.88419 12.7843 7.88086 13.468 8.41644V5.3333C13.468 4.15509 12.5129 3.19997 11.3347 3.19997L4.66802 3.19997ZM13.468 9.90565L12.8839 9.3215C12.5914 9.02887 12.1239 9.00766 11.806 9.2726L10.6728 10.2171L12.6711 12.3296C13.1571 11.9385 13.468 11.3389 13.468 10.6666V9.90565ZM11.6288 12.7799L7.48216 8.3963C6.92728 7.80971 6.00263 7.78195 5.41356 8.3342L2.56181 11.0077C2.72508 12.0238 3.60591 12.8 4.66802 12.8H11.3347C11.4345 12.8 11.5326 12.7931 11.6288 12.7799ZM1.476 10.8943C1.59277 12.5554 2.97727 13.8666 4.66802 13.8666H11.3347C13.102 13.8666 14.5347 12.4339 14.5347 10.6666V5.3333C14.5347 3.56599 13.102 2.1333 11.3347 2.1333L4.66802 2.1333C2.90071 2.1333 1.46802 3.56599 1.46802 5.3333L1.46802 10.6666C1.46802 10.6989 1.4685 10.731 1.46945 10.7631C1.46625 10.8068 1.46842 10.851 1.476 10.8943ZM10.2097 5.28363C9.76786 5.28363 9.40969 5.6418 9.40969 6.08363C9.40969 6.52546 9.76786 6.88363 10.2097 6.88363C10.6515 6.88363 11.0097 6.52546 11.0097 6.08363C11.0097 5.6418 10.6515 5.28363 10.2097 5.28363ZM8.34302 6.08363C8.34302 5.0527 9.17875 4.21696 10.2097 4.21696C11.2406 4.21696 12.0764 5.0527 12.0764 6.08363C12.0764 7.11456 11.2406 7.9503 10.2097 7.9503C9.17875 7.9503 8.34302 7.11456 8.34302 6.08363Z" fill="black" />
                            </svg>

                        </div>

                        <p>Build static
                            creatives</p>
                    </div>
                    <div className="price-info-item">
                        <div className="price-info-item__icon">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2279 6.96285C12.0232 7.42562 12.0232 8.57446 11.2279 9.03723L6.91789 11.5451C6.1179 12.0106 5.11437 11.4335 5.11437 10.5079L5.11437 5.49216C5.11437 4.56659 6.11789 3.98947 6.91789 4.45496L11.2279 6.96285ZM10.6914 8.11529C10.7798 8.06387 10.7798 7.93622 10.6914 7.8848L6.38143 5.37691C6.29254 5.32519 6.18104 5.38931 6.18104 5.49216L6.18104 10.5079C6.18104 10.6108 6.29254 10.6749 6.38143 10.6232L10.6914 8.11529Z" fill="black" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99943 13.6C11.0922 13.6 13.5994 11.0928 13.5994 8.00004C13.5994 4.90725 11.0922 2.40004 7.99943 2.40004C4.90664 2.40004 2.39943 4.90725 2.39943 8.00004C2.39943 11.0928 4.90664 13.6 7.99943 13.6ZM7.99943 14.6667C11.6813 14.6667 14.6661 11.6819 14.6661 8.00004C14.6661 4.31814 11.6813 1.33337 7.99943 1.33337C4.31753 1.33337 1.33276 4.31814 1.33276 8.00004C1.33276 11.6819 4.31753 14.6667 7.99943 14.6667Z" fill="black" />
                            </svg>


                        </div>

                        <p>Create AI avatar
                            videos</p>
                    </div>
                </div>
                <div style={{ position: 'relative', margin: '0 auto 10rem', display: 'flex', justifyContent: 'center' }}>
                    <PriceInfo sessionId={sessionId} eventName={'web_click_pricepricing'} setShowTermBundle={setShowTermBundle} text="After the offer ends, you’ll switch to regular pricing" />
                </div>

                <MyButton
                    // ref={nextPageButtonRef}
                    buttonStatus={'price'}
                    buttonTime={150}
                    buttonText={[`Get Growth for ${activePrice}`, activeOldPrice]}
                    onClick={() => {
                        mixpanel.track('web_price', {
                            session_id: sessionId,
                            web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
                            user_id: localStorage.getItem('userId'),
                            // web_pay_method: 'CreditCard',
                            web_utm_campaign: localStorage.getItem("utmCampaign"),
                            web_utm_source: localStorage.getItem("utmSource"),
                            web_utm_medium: localStorage.getItem("utmMedium"),
                            web_utm_content: localStorage.getItem("utmContent"),
                            web_utm_term: localStorage.getItem("utmTerm"),
                            isDebug: false,
                            funnel: 'MAIN_v1',
                        });
                        history.push('/trial');
                    }}


                >
                </MyButton>
                <div className="price-rated">
                    <div className="price-rated-top">
                        Rated 4.6
                        <img src={process.env.PUBLIC_URL + '/img/stars.svg'} alt="" />

                    </div>
                    <p>+9.3k ratings</p>
                </div>
                <div className="price-cancel">
                    {/* <div className="price-cancel-item">
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.02869 1.53255C9.8311 0.696643 11.1689 0.696642 11.9713 1.53255C12.4705 2.05255 13.2075 2.2703 13.9091 2.1047C15.0311 1.83984 16.1528 2.57657 16.3783 3.70716C16.5197 4.41581 17.024 5.00876 17.7041 5.25309C18.793 5.6443 19.3409 6.8693 18.9237 7.94854C18.6623 8.62455 18.7703 9.39791 19.2107 9.97357C19.9165 10.8963 19.7296 12.2233 18.7923 12.9098C18.2084 13.3375 17.8907 14.0498 17.9528 14.771C18.0517 15.9205 17.1832 16.9445 16.0313 17.0098C15.311 17.0507 14.6624 17.4734 14.3291 18.1133C13.7956 19.1374 12.5122 19.5228 11.5099 18.9495C10.8842 18.5916 10.1158 18.5916 9.49013 18.9495C8.48778 19.5228 7.20441 19.1374 6.67092 18.1133C6.33759 17.4734 5.68904 17.0507 4.96872 17.0098C3.81683 16.9445 2.94827 15.9205 3.04721 14.771C3.10927 14.0498 2.79163 13.3375 2.20767 12.9098C1.27036 12.2233 1.08345 10.8963 1.78932 9.97357C2.22966 9.39791 2.33766 8.62455 2.07634 7.94854C1.65913 6.8693 2.20698 5.6443 3.29591 5.25309C3.97596 5.00876 4.48031 4.41581 4.62167 3.70716C4.8472 2.57657 5.96891 1.83984 7.09095 2.1047C7.79247 2.2703 8.52953 2.05255 9.02869 1.53255Z" fill="black" />
                            <path d="M7 9.99982L9.5 12.4998L14 7.99982" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>

                        <p>100% money-back guarantee</p>
                    </div> */}
                    <div className="price-cancel-item">
                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50263 20C12.3069 18.427 16.5 14.7524 16.5 10.4645C16.5 4.74981 16.5 2.70721 16.5 2.70721L8.50263 0L0.5 2.70978C0.5 2.70978 0.5 4.75237 0.5 10.467C0.5 14.7524 4.70099 18.427 8.50263 20Z" fill="black" />
                            <path d="M5 9.5L7.5 12L12 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <p>No commitments. Cancel anytime.</p>
                    </div>
                </div>
            </div>



        </div>
    );
}

export default Price4;
